import { useMutation, useQueryClient } from '@tanstack/react-query'
import { fetchApi } from '~/api/utils'
import { publicShortlistQueryKey } from '../queries/publicShortlist'
import type { PublicShortlist, ShortlistSubmissionLine } from '../types'

export const useSubmitShortlist = (instance: string, token: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (lines: ShortlistSubmissionLine[]) =>
      fetchApi({
        url: `/v1/public/shortlists/${token}/submit`,
        method: 'POST',
        data: { lines },
        instance
      }),
    onSuccess: () => {
      queryClient.setQueryData<PublicShortlist>(
        publicShortlistQueryKey(token),
        (current) =>
          current === undefined
            ? current
            : { ...current, submitted: true, applicants: [] }
      )
    },
    onError: () => {
      void queryClient.invalidateQueries({
        queryKey: publicShortlistQueryKey(token)
      })
    }
  })
}
